



















































import Vue from 'vue';
import { mapState } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    Pagination,
    Header,
    Loading,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
    };
  },

  computed: {
    ...mapState({
      examApplications: (state: any) => state.examApplications.examApplications,
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/fontes`);
    }
    this.loaded = false;
    await this.$store.dispatch('PULL_EXAM_APPLICATIONS', this.currentPage);
    this.loaded = true;
  },

  methods: {
    removeExamApplication: async function(
      examApplicationId: number,
      index: number,
    ) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa fonte? Ela não poderá ser recuperada!',
        )
      ) {
        let response = await this.$store.dispatch(
          'REMOVE_EXAM_APPLICATION',
          examApplicationId,
        );

        if (response === true) {
          this.$store.commit('REMOVE_EXAM_APPLICATION', index);
        } else {
          //TODO analyze the error
          alert('Essa fonte não pode ser deletada!');
        }
      }
    },

    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      let currentPage = this.currentPage;
      await this.$store.dispatch('PULL_EXAM_APPLICATIONS', { currentPage });
      this.loaded = true;
      this.$router.push(`/fontes/${this.currentPage + 1}`);
    },
  },
});
